import React, { useState } from 'react';
import { Mail, MailCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ApiService } from '../../utils/api';
import { useToast } from '../Toast';

const ForgotPasswordForm = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await ApiService.forgotPassword(email.trim());
      setSent(true);
    } catch (error) {
      showError(error.message || 'Could not send the reset link. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl font-bold">Reset password</CardTitle>
        <p className="text-gray-600">
          {sent ? 'Check your inbox' : "Enter your account email and we'll send you a reset link."}
        </p>
      </CardHeader>
      <CardContent>
        {sent ? (
          <div className="space-y-4 text-center">
            <MailCheck className="w-12 h-12 text-green-600 mx-auto" />
            <p className="text-sm text-gray-700">
              If an account exists for <strong>{email}</strong>, a reset link is on its way. It expires in 30 minutes.
            </p>
            <Button variant="outline" className="w-full" onClick={() => setSent(false)}>
              Send again
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="reset-email" className="text-sm font-medium">Email Address</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <Input
                  id="reset-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="pl-10"
                  autoComplete="email"
                  required
                />
              </div>
            </div>
            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        )}
        <div className="mt-6 text-center">
          <button type="button" onClick={onBackToLogin} className="text-sm text-blue-600 hover:text-blue-500 font-medium">
            Back to sign in
          </button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ForgotPasswordForm;
